import React, { useEffect, useState } from "react";
import "./Nav.css";
function Nav() {
  const [background, setBackground] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setBackground(true);
      } else setBackground(false);
    });
  }, []);
  return (
    <div className={`nav ${background && "nav_black"}`}>
      <img
        className="nav_logo"
        src="https://about.netflix.com/images/logo.png"
        alt="Netflix Logo"
      />
      <img
        className="nav_avatar"
        src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png"
        alt="Netflix Avatar Logo"
      />
    </div>
  );
}

export default Nav;
